import React, { useState, useEffect } from "react";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import axios from "axios";
import toastr from "toastr";
import {
  Link,
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";

const OrderDetails = () => {
  const [orderDetails, setOrderDetails] = useState(null);
  const location = useLocation();
  const { id } = location.state;
  const history = useHistory();
  const delivery = 0;
  const getOrderDetails = async () => {
    try {
      const response = await axios.get(
        `http://api.meddaily.in/order_details?order_id=${id}`,
        {
          headers: {
            token: localStorage.getItem("disToken"),
          },
        }
      );
      if (response.status === 200) {
        setOrderDetails(response?.data?.data);
        console.log(response.data.data);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleApprove = async () => {
    try {
      const response = await axios.post(
        "http://api.meddaily.in/return_order_accept",
        {
          order_id: orderDetails.order_id,
        },
        {
          headers: {
            token: localStorage.getItem("disToken"),
          },
        }
      );
      if (response.status === 200) {
        toastr.success(response.data.message);
        history.push("/");
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getOrderDetails();
  }, []);

  const totalPriceqty =
    orderDetails?.products &&
    orderDetails.products.reduce(
      (total, item) => total + item.price * item.quantity,
      0
    );

  const calTax = (totalPriceqty * orderDetails?.applicable_tax) / 100;

  const orderTotal = totalPriceqty + calTax;

  console.log("object", orderTotal);
  return (
    <>
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Sidebar />
          <div className="layout-page">
            <Navbar />

            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row">
                  <div className="card mb-12">
                    <div className="card-header d-flex justify-content-between align-items-center"></div>

                    <div className="card-body">
                      <div className="container-xxl flex-grow-1 container-p-y">
                        <div className="row">
                          <div className="card mb-3">
                            <div className="card-body">
                              <h2 className="card-title text-start">
                                Return Details
                              </h2>
                              <div className="row">
                                <div className="col-md-6">
                                  <strong>Order ID:</strong>{" "}
                                  {orderDetails?.order_id}
                                </div>
                                <div className="col-md-6">
                                  <strong>Distributor Name:</strong>{" "}
                                  {orderDetails?.distributor_name}
                                </div>
                                <div className="col-md-6">
                                  <strong>Retailer Name:</strong>{" "}
                                  {orderDetails?.retailer_name}
                                </div>
                                <div className="col-md-6">
                                  <strong>Order Status:</strong>{" "}
                                  {orderDetails?.order_status === 0 &&
                                    "Cancelled"}
                                  {orderDetails?.order_status === 1 &&
                                    "Order Shipped"}
                                  {orderDetails?.order_status === 3 &&
                                    "Order Delivered"}
                                  {orderDetails?.order_status === 4 &&
                                    "Order Placed"}
                                </div>
                                <div className="col-md-6">
                                  <strong>Batch no:</strong>{" "}
                                  {orderDetails?.batch_no}
                                </div>
                                <div className="col-md-6">
                                  <strong>Exp Date:</strong>{" "}
                                  {orderDetails?.exp_date}
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="card mb-3">
                            <div className="card-body">
                              <h2 className="card-title text-start">
                                Order Items
                              </h2>
                              <table className="table">
                                <thead>
                                  <tr>
                                    <th>Name</th>
                                    <th>Price</th>
                                    <th>Quantity</th>
                                    <th>Return Qty</th>
                                    <th>Purchase Qty</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {orderDetails?.products &&
                                    orderDetails.products.map(
                                      (product, index) => (
                                        <tr key={index}>
                                          <td>{product?.name}</td>
                                          <td>{product?.price}</td>
                                          <td>{product?.quantity}</td>
                                          <td>
                                            {orderDetails?.return_quantity}
                                          </td>
                                          <td>
                                            {orderDetails?.products[0].quantity}
                                          </td>
                                        </tr>
                                      )
                                    )}
                                </tbody>
                              </table>
                            </div>
                          </div>

                          <div className="card">
                            <div className="card-body">
                              <h2 className="card-title text-start">
                                Estimated Return Value
                              </h2>
                              <table className="table">
                                <tbody>
                                  <tr>
                                    {/* <th scope="row">Return Qty:</th> */}
                                  </tr>
                                  <tr>
                                    {/* <th scope="row">Purchase Qty:</th> */}
                                    <td>
                                      {/* {orderDetails?.products[0].quantity} */}
                                    </td>
                                  </tr>
                                  <tr>
                                    <th scope="row">Item Total:</th>
                                    <td>{totalPriceqty}</td>
                                  </tr>
                                  {/* <tr>
                                    <th scope="row">Tax:</th>
                                    <>{calTax}</
                                    td>
                                  </tr> */}
                                  <tr>
                                    <th scope="row">Tax:</th>
                                    <td>{calTax}</td>
                                  </tr>
                                  <tr>
                                    <th scope="row">Delivery Fee:</th>
                                    <td>{delivery}</td>
                                  </tr>
                                  <tr>
                                    <th scope="row">Return Total:</th>
                                    <td>{orderTotal}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="mb-5">
                      {/* {orderDetails?._id && (
                        <Link
                          to={{
                            pathname: "/invoice",
                            state: {
                              orderid: id,
                            },
                          }}
                        >
                          <button
                            className="btn btn-primary"
                            style={{
                              backgroundColor: "#6eafab",
                              border: "1px solid #6eafab",
                            }}
                          >
                           Approve Return
                          </button>
                        </Link>
                      )} */}
                      {orderDetails?._id && (
                        <button
                          className="btn btn-primary"
                          style={{
                            backgroundColor: "#6eafab",
                            border: "1px solid #6eafab",
                          }}
                          onClick={handleApprove}
                        >
                          Approve Return
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OrderDetails;
